import _ from "lodash";
import {entities as staticEntities} from "../staticEntities";

// Libellé d'un statut, repris des entités statiques (ActionStatus, WorkItemStatus)
const statusLabel = (entityName, id) => {
    const entity = staticEntities.find(staticEntity => staticEntity.name === entityName)
    const status = _.find(_.get(entity, 'objects'), {id})
    return status ? status.name : id
}

// Message système du « Suivi » (affiché avec le logo, cf. cnda/liberality/liberalityFile.js)
export const statusMessage = (fromId, toId, entityName, context) => ({
    id: new global.ObjectID().toString(),
    text: `Statut : ${statusLabel(entityName, fromId)} → ${statusLabel(entityName, toId)}`,
    sender: _.pick(context.user, ['id', 'name']),
    responseTo: null,
    parentMessage: null,
    seenBy: [context.user.id],
    files: [],
    timestamp: new Date().toISOString(),
    from: 'system'
})

// Forme enregistrée en base d'un message, pour un $push direct sur un document
// dont le « Suivi » n'est pas dans le formulaire enregistré (sinon il serait écrasé)
export const storedMessage = (message, context) => ({
    ..._.omit(message, ['id']),
    _id: new global.ObjectID(message.id),
    group: new global.ObjectID(context.group.id)
})

// Messages de changement de statut des actions enregistrées depuis un parent (Travaux, Opportunité)
export const pushActionStatusMessages = async (changes = [], context) => {
    for (const change of changes) {
        const message = statusMessage(change.from, change.to, 'ActionStatus', context)
        await global.app.K.Action.collection.updateOne(
            {_id: new global.ObjectID(change.id)},
            {$push: {conversations: storedMessage(message, context)}}
        )
    }
}
